import { AnswerTypes } from './enums';

export const questions = [
  {
    name: 'a945d8f7-ade3-428e-aa9d-b9f33e28d5fc',
    text: 'Thinking about your physical health, which includes physical illness and injury, how many days during the past 30 days was your physical health not good?',
    answerType: AnswerTypes.NULLABLETEXTBOX,
    options: [
      {
        name: 'afc3ab7a-568d-487e-944e-b65c7b25b782',
        text: 'Number of days (1-30)',
      },
      {
        name: 'd5b55645-b6fc-4238-9ac8-ff2e908e2eee',
        text: 'None',
      },
    ],
  },
  {
    name: '4b250edf-b739-4a55-80cb-ed1bbd0c6b3c',
    text: 'Thinking about your mental health, which includes stress, depression, and problems with emotions, how many days during the past 30 days was your mental health not good?',
    answerType: AnswerTypes.NULLABLETEXTBOX,
    options: [
      {
        name: 'f1e8654b-0a3b-4c03-be53-b549e50ef420',
        text: 'Number of days (1-30)',
      },
      {
        name: '03c36ccb-2441-4f27-a8f7-1819e22006a1',
        text: 'None',
      },
    ],
  },
  {
    name: '1c92f809-2f59-45cf-b8bc-0b977653780f',
    text: "Do you ever feel unsteady or wobbly when you're walking, running, or climbing? Or have you ever tripped or fallen down more often than your friends?",
    options: [
      {
        name: 'dd45067a-6527-4d57-89a9-477343da057e',
        text: 'Yes',
      },
      {
        name: '81d9fea5-ddbd-4d20-bef2-4012fb55600d',
        text: 'No',
      },
      {
        name: '775cad95-747a-4a0d-9af7-b631c5dfed3e',
        text: 'Not sure',
      },
    ],
  },
  {
    name: '63c084fd-4fae-466a-b8fa-97c3e256afe6',
    text: 'If yes, have you discussed with your provider strategies for reducing fall risks?',
    dependencies: ['dd45067a-6527-4d57-89a9-477343da057e'],
    options: [
      {
        name: '499c70ee-ef01-4710-93e8-8d36a2c7504d',
        text: 'Yes',
      },
      {
        name: '6f0d3a49-fef8-43c7-b8c2-7e64555afd4a',
        text: 'No',
      },
      {
        name: 'f8a1176d-00de-4a50-9540-572e6f240973',
        text: 'Not sure',
      },
    ],
  },
  {
    name: '31dc56cd-2c43-4554-9110-362485f94d0f',
    text: 'Have you discussed with your provider ways to increase or maintain your physical activity levels?',
    options: [
      {
        name: '9eae6544-eb6b-4a0d-a841-5350f001a1d2',
        text: 'Yes',
      },
      {
        name: 'ccaee8a0-a3fc-4a66-90da-f1ec526be8d7',
        text: 'No',
      },
      {
        name: 'f6f7cecc-191c-4a83-b2e2-a61bb6740a47',
        text: 'Not sure',
      },
    ],
  },
  {
    name: '29756bed-ac2c-444a-8829-8000871f6a79',
    text: 'Do you ever have trouble making it to the bathroom in time when you need to go, or do you sometimes have accidents even though you tried to get to the bathroom?',
    options: [
      {
        name: '7d62f982-a32c-4ea7-ad12-12435f850d99',
        text: 'Yes',
      },
      {
        name: '4e7c7d80-3f21-4f8b-886b-496ae6b5c957',
        text: 'No',
      },
      {
        name: 'bfee0277-81c5-43d4-b4d0-b6830eed7b0f',
        text: 'Not sure',
      },
    ],
  },
  {
    name: 'ba6297bd-7214-48c9-ade0-bf773f5f8b9e',
    text: 'If yes, Have you discussed with your provider methods to improve bladder control?',
    dependencies: ['7d62f982-a32c-4ea7-ad12-12435f850d99'],
    options: [
      {
        name: 'a1c6cd2a-45ad-4e96-9eda-54887ae23d6c',
        text: 'Yes',
      },
      {
        name: 'b83a7a30-2138-4112-a263-61cfc0999a4c',
        text: 'No',
      },
      {
        name: '1b9c0836-a35a-4247-8db0-d145ee663c3e',
        text: 'Not sure',
      },
    ],
  },
  {
    name: '68688e64-ab35-4768-8957-87dca12d9ba3',
    text: 'Was there a time in the past 12 months when you needed to see a doctor but could not because you could not afford it?',
    options: [
      {
        name: 'eca2edb3-c8a6-406b-9819-72fa57e8bcf0',
        text: 'Yes',
      },
      {
        name: 'bf107586-35d3-4eef-b3e6-577c9348147f',
        text: 'No',
      },
      {
        name: 'b83b32a4-70f5-46a5-a12b-fc52c24d00b7',
        text: 'Not sure',
      },
    ],
  },
  {
    name: '98a18e9d-ef66-402b-a245-3516bd402ed7',
    text: 'About how long has it been since you last visited a doctor for a routine checkup?',
    options: [
      {
        name: 'ebbc7f82-d990-4893-89de-44cfbeacf07b',
        text: 'Within the past year (anytime less than 12 months ago)',
      },
      {
        name: '102dcb43-0222-48cd-8049-f25badda4745',
        text: 'Within the past 2 years (>1 year but less than 2 years ago)',
      },
      {
        name: 'fbd42548-a336-46b8-b6e3-679a3791dd37',
        text: 'Within the past 5 years (>2 years but less than 5 years ago)',
      },
      {
        name: 'd7cbbe30-55cf-4c15-ad63-1a7f31504a7f',
        text: '4-5 or more years ago',
      },
    ],
  },
  {
    name: '03c3c49c-fdd2-4902-9de4-39dfa27b52b2',
    text: 'How often do you need to have someone help you when you read instructions, pamphlets, or other written material from your doctor or pharmacist?',
    options: [
      {
        name: 'd5247f3d-bfd1-4533-b22c-4daeecbbccc4',
        text: 'Never',
      },
      {
        name: '74ac9167-1097-46ba-8282-b9803c2a3a75',
        text: 'Rarely',
      },
      {
        name: '34a6dbe8-2a83-42db-9827-8fa8e6483f9f',
        text: 'Sometimes',
      },
      {
        name: 'dd0e6312-bdab-4faa-819e-2eea354166bb',
        text: 'Often',
      },
      {
        name: '8f43a3ee-37de-46bc-9b67-5dfa32781f65',
        text: 'Always',
      },
    ],
  },
  {
    name: '702046cc-c550-442a-9a0d-d9aa4e54302b',
    text: 'People sometimes miss taking their medications for reasons other than forgetting. Thinking over the past 2 weeks, were there any days when you did not take your medicine?',
    options: [
      {
        name: '49120f00-caef-4a7e-a0bf-2e60dbd7ccb6',
        text: 'Yes',
      },
      {
        name: '7cacf499-16ca-45da-915a-9757396f4143',
        text: 'No',
      },
    ],
  },
];
